import { render, staticRenderFns } from "./radio-field.component.vue?vue&type=template&id=d66bb7cc&"
import script from "./radio-field.component.ts?vue&type=script&lang=ts&"
export * from "./radio-field.component.ts?vue&type=script&lang=ts&"
import style0 from "./radio-field.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
